module.exports = __webpack_public_path__ + "assets/media/day19.e4b20d33.mp3";